<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-safra') {
            next({ name: 'agro-safra-list' });
        } else if (to.name == 'ven-safra') {
            next({ name: 'ven-safra-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-safra') {
            this.$router.push({ name: 'agro-safra-list' });
        } else if (this.$route.name == 'ven-safra') {
            this.$router.push({ name: 'ven-safra-list' });
        }
    },
};
</script>
